import { Google } from 'reaxl-analytics';
export function dealerRatingClick(_ref, option) {
  let {
    data = {}
  } = _ref;
  const {
    ratingSource,
    value,
    count,
    id
  } = data;
  Google.sendClickEvent({
    eventElement: 'dealer-rating',
    eventResult: `rating::${ratingSource}::${value}::${count}`,
    eventData: {
      svocId: id?.toString()
    }
  }, option);
  return {};
}
export function dealerRatingImpressions(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    data = {}
  } = metadata;
  const {
    id
  } = data;
  Google.sendImpressions(metadata, {
    eventElement: 'dealer-rating',
    eventResult: 'rating',
    eventData: {
      svocId: id?.toString()
    }
  }, option);
  return {};
}